import { ConstructionComponentInfo } from "@interfaces/constructor/constructor"
import UserAvatar from "./userAvatar"
import UserBalance from "./userBalance"
import UserCreateDate from "./userCreateDate";
import UserEmail from "./userEmail"
import UserLastAuth from "./userLastAuth"
import UserName from "./userName"
import UserPublicName from "./userPublicName"

const UserNameInfo: ConstructionComponentInfo = {
    component: UserName
}

const UserEmailInfo: ConstructionComponentInfo = {
    component: UserEmail
}

const UserBalanceInfo: ConstructionComponentInfo = {
    component: UserBalance
}

const UserCreateDateInfo: ConstructionComponentInfo = {
    component: UserCreateDate,
    props: [
        'format'
    ]
}

const UserPublicNameInfo: ConstructionComponentInfo = {
    component: UserPublicName
}

const UserAvatarInfo: ConstructionComponentInfo = {
    component: UserAvatar
}

const UserLastAuthInfo: ConstructionComponentInfo = {
    component: UserLastAuth,
    props: [
        'format'
    ]
}

export {
    UserAvatarInfo,
    UserBalanceInfo,
    UserCreateDateInfo,
    UserEmailInfo,
    UserLastAuthInfo,
    UserPublicNameInfo,
    UserNameInfo
}